
import { NavigationGuardNext, Route } from 'vue-router'
import { registerModule } from '@/app/app.store'

import { isLogin, toLogin } from '@utils/index'
import GrowthSouvenir from '../index.vue'
import Common from '../../common.vue'
// import Common from '../common.vue'
export default {
  path: '/',
  component: Common,
  children: [
    {
      name: 'scenicTourism',
      path: 'scenicTourism',
      component: () => import('../index.vue'),
      beforeEnter: (to: any, from: any, next: () => void) => {
        import('../service/index').then(({ STORE }) => {
          if (STORE) registerModule(to, STORE)
          next()
        })
      }
    },
  ]
}

